import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoggerService } from 'src/app/services/Non-Master/logger.service';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { tPatientTypeModel } from 'src/app/models/tPatientTypeModel';
import { tPatientTypeService } from 'src/app/services/tPatientType.service';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { tPatientService } from 'src/app/services/tPatient.service';
import { TranslateService } from '@ngx-translate/core';
import { AppSettings } from 'src/app/shared/AppSettings';
import { StatusMessage } from 'src/app/shared/StatusMessage';
import { MastersKeyStringValue } from 'src/app/services/Non-Master/MastersKeyStringValue.service';
import { ApiResultDialogService } from 'src/app/services/Non-Master/ApiResultDialog.service';
import { ApiResultHandlerService } from 'src/app/services/Non-Master/ApiResultHandler.service';
import { isNullOrUndefined } from 'util';
import { CrypService } from 'src/app/services/Non-Master/Cryp.service';
import { SimpleConfigService } from 'src/app/services/SimpleConfig.service';
import { GenderModel, GenderTitleModel } from 'src/app/models/SimpleConfigModel';


@Component({
  selector: 'app-new-patient-dialog',
  templateUrl: './new-patient-dialog.component.html',
  styleUrls: ['./new-patient-dialog.component.css']
})
export class NewPatientDialogComponent implements OnInit {

  //form
  editForm: FormGroup;
  submitted = false;
  TAG = "NewPatientDialogComponent";

  patientTitle_selection;
  patientGender_selection;
  patientTypeID_selection: tPatientTypeModel[];

  genderList: GenderModel[];
  genderTitleList: GenderTitleModel[];
  showEng = false;
  remark3_selection;

  emailFormControl = new FormControl('', Validators.email);

  constructor(public activeModal: NgbActiveModal,
    private log: LoggerService,
    private router: Router,
    private formBuilder: FormBuilder,
    private tPatientTypeService: tPatientTypeService,
    private tPatientService: tPatientService,
    private translate: TranslateService,
    private apiResultDialogService: ApiResultDialogService,
    private apiResultHandlerService: ApiResultHandlerService,
    private CrypService: CrypService,
    private SimpleConfigService: SimpleConfigService,

  ) { }

  ngOnInit() {
    this.setDefaultLanguageString(AppComponent.usingLanguage);

    this.editForm = this.formBuilder.group({

      patientTypeID: [],
      //patientTypeID: new FormControl(this.patientTypeID_selection[0].pTypeID),

      patientID: [''],
      patientTitle: [],
      patientGender: [],

      patientChiName: ['', [Validators.required]],
      patientSurname: ['', ''],
      patientFirstName: ['', ''],

      phoneAreaCode: ['', ''],

      patientPhone: ['', [Validators.required]],
      patientPhone2: ['', ''],

      patientMedCard1: ['', ''],
      patientMedCard2: ['', ''],

      shopName: [],
      shopID: [],


      lastModifyDatetime: ['', ''],
      lastModifyUserID: [],

      userName: [],
      lastModifyDatetimeDisplay: [],


      patientPhone_str: [],
      patientPhone2_str: [],

      patientIHKID_str: [],
      patientAddress_str: [],
      patientDob_str: [],
      patientEmail: this.emailFormControl,
      patientRemark3: ['N']

    });


    this.getPatientTypeList();
    this.getGender();
  }

  setDefaultLanguageString(language: String) {
    switch (language) {
      case SystemDefaultModel.Language_Chinese:
        this.remark3_selection = ChineseDefaultModel.InActiveList;

        this.showEng = false;
        break;
      case SystemDefaultModel.Language_English:
        this.remark3_selection = ChineseDefaultModel.InActiveList;

        this.showEng = true;

        break;
      default:
        
        this.showEng = false;
        this.remark3_selection = ChineseDefaultModel.InActiveList;

        break;
    }
  }

  get f() { return this.editForm.controls; }


  getPatientTypeList() {
    this.tPatientTypeService.getAllData().subscribe(data => {
      this.patientTypeID_selection = data;
      this.editForm.get('patientTypeID').setValue(this.patientTypeID_selection[0].pTypeID);

      this.log.i(this.TAG, "getPatientTypeList data = " + JSON.stringify(this.patientTypeID_selection));
    });
  }


  onSubmit() {

    this.log.i(this.TAG, 'onSubmit data = ' + JSON.stringify(this.editForm.value));

    if(this.editForm.value.patientRemark3 == "Y" &&  this.editForm.value.patientEmail == "")
    {      
      alert("需輸入電郵");

      return;
    }

    this.submitted = true;


    if (this.editForm.valid) {
      let returnDisplayMsg: string;

      this.editForm.get('shopID').setValue(NavigationComponent.selectedShopID);
      this.editForm.get('lastModifyUserID').setValue(NavigationComponent.userID);


      const patientPhone_str = this.CrypService.encryptStr(this.editForm.get('patientPhone').value);

      let patientPhone2_str = this.CrypService.encryptStr('0');
      if (!isNullOrUndefined(this.editForm.get('patientPhone2').value) && this.editForm.get('patientPhone2').value !== '') {
        patientPhone2_str = this.CrypService.encryptStr(this.editForm.get('patientPhone2').value);
      }

      this.editForm.get('patientPhone').setValue(0);
      this.editForm.get('patientPhone2').setValue(0);
      this.editForm.get('patientPhone_str').setValue(patientPhone_str);
      this.editForm.get('patientPhone2_str').setValue(patientPhone2_str);


      this.log.i(this.TAG, 'onSubmit data = ' + JSON.stringify(this.editForm.value));


      this.tPatientService.addData(this.editForm.value)
        .subscribe(data => {
          this.log.i(this.TAG, 'onSubmit success , data = ' + JSON.stringify(data));
          // 


          var returnData: any = data;

          // just close the dialog if success
          if (returnData.statusCode == StatusMessage.Status_OK) {

            this.activeModal.close(returnData.data);
            // this.activeModal.close('OK');

          }

          //show result dialog
          this.apiResultHandlerService.ResultHandler(
            data,
            AppSettings.Path_tPatient + AppSettings.PATH_NEW,
            '');
        },
          err => {
            this.log.i(this.TAG, 'onsubmit error = ' + JSON.stringify(err));
            this.apiResultHandlerService.ErrHandler();
          });
    }
  }


  openAPI_Result_Modal(action, msg) {
    this.log.i(this.TAG, 'openConfirmModal action = ' + action);
    this.apiResultDialogService.openDialog(action, '', status, msg);
  }

  getGender() {
    console.log("do getPatientGender");
    
    this.SimpleConfigService.getAllData().subscribe((data => {

      this.genderList = data.patientGenderModelList;
      this.genderTitleList = data.patientGenderTitleModelList;

      this.editForm.get('patientGender').setValue(this.genderList[0].id);
      this.editForm.get('patientTitle').setValue(this.genderTitleList[0].id);



    }), err => {
      console.log("getPatientGender error");
    });
  }
}
